import {
  IonAccordion,
  IonAccordionGroup,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonItem,
  IonRange,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { makeGETRequest } from "../../../request/rawRequest";

interface Props {
  pole: number;
  type: string;
}

interface ThemeStat {
  name: string;
  totalVideo: number;
  viewedVideo: number;
}

interface CompStat {
  name: string;
  _id: string;
  isLoad: boolean;
  themes: ThemeStat[];
}

const getVideo = (amount: number) => {
  switch (amount) {
    case 0:
    case 1:
      return "vidéo";

    default:
      return "vidéos";
  }
};

const StatsPoleTutorials: React.FC<Props> = ({ pole, type }) => {
  const [comps, setComps] = useState<CompStat[]>([]);
  const [userEmail, setUserEmail] = useState<string>("");
  const [fetch, setFetch] = useState<boolean>(false);

  useEffect(() => {
    makeGETRequest("/me").then((res) => {
      setUserEmail(res.email);
    });

    makeGETRequest(
      `/stats/skills?genre=tutorial&pole=${pole}&type=${type}`
    ).then((res) => {
      for (const comp of res) {
        const { skill_name, id_skills, themes } = comp;
        setComps((old) => [
          ...old,
          {
            _id: id_skills,
            isLoad: false,
            name: skill_name,
            themes: [],
          },
        ]);
      }
    });
  }, []);

  return (
    <IonAccordionGroup>
      {comps.map((comp, indexC) => {
        return (
          <IonAccordion
            key={indexC}
            onClick={() => {
              if (comp.isLoad === false) {
                setFetch(true);
                makeGETRequest(
                  `/stats/details/tutorials?id_skills=${comp._id}&email=${userEmail}`
                ).then((res) => {
                  setComps((old) => [
                    ...old.slice(0, indexC),
                    {
                      ...old[indexC],
                      isLoad: true,
                      themes: res.themes.map((theme: any): ThemeStat => {
                        return {
                          name: theme.theme_name,
                          totalVideo: theme.total_video,
                          viewedVideo: theme.video_viewed,
                        };
                      }),
                    },
                    ...old.slice(indexC + 1, old.length),
                  ]);
                  setFetch(false);
                });
              }
            }}
          >
            <IonItem slot="header">{comp.name}</IonItem>
            <div slot="content">
              {fetch === true ? (
                <div>Chargement ....</div>
              ) : (
                comp.themes.map((theme, indexT) => {
                  return (
                    <IonCard key={indexT}>
                      <IonCardHeader>
                        <IonCardTitle>{theme.name}</IonCardTitle>
                      </IonCardHeader>

                      <IonCardContent>
                        <IonItem>
                          Tu as vu {theme.viewedVideo}{" "}
                          {getVideo(theme.viewedVideo)}
                        </IonItem>
                        <IonRange
                          key={theme.totalVideo + theme.viewedVideo + indexT}
                          style={{
                            pointerEvents: "none",
                          }}
                          min={0}
                          max={100}
                          value={(theme.viewedVideo / theme.totalVideo) * 100}
                          pin={true}
                          pinFormatter={(value) => `${value}%`}
                        >
                          <div slot="start">{theme.viewedVideo}</div>
                          <div slot="end">{theme.totalVideo}</div>
                        </IonRange>
                      </IonCardContent>
                    </IonCard>
                  );
                })
              )}
              {}
            </div>
          </IonAccordion>
        );
      })}
    </IonAccordionGroup>
  );
};

export default StatsPoleTutorials;
